var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelPrint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 47,
  height: 60,
  viewBox: "0 0 47 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M41.92.1c2.396-.484 4.936.829 4.936 2.947v34.708c0 2.121-1.973 4.235-4.408 4.728l-6.362 1.289v13.145c0 1.938-1.692 3.101-3.794 2.596L3.794 52.657C1.698 52.153 0 50.177 0 48.236V12.539c0-2.122 1.974-4.235 4.408-4.729ZM30.899 44.55l-20.804 4.48 20.804 5.52zm-2.82-13.058-17.27 3.173a2.423 2.423 0 0 0 .876 4.766l17.269-3.173a2.423 2.423 0 1 0-.876-4.766m8.15-11.709-25.572 4.7a2.423 2.423 0 0 0 .875 4.765l25.573-4.699a2.423 2.423 0 1 0-.876-4.766m-.12-9.97-25.573 4.7a2.423 2.423 0 0 0 .876 4.765l25.573-4.699a2.423 2.423 0 1 0-.876-4.766"
})));
export default SvgChannelPrint;